import { ref } from 'vue';

// Module-level singletons — intentionally shared as a global progress bar
const progress = ref<number>(0);
const visible = ref<boolean>(false);
let timer: ReturnType<typeof setInterval> | null = null;
let hideTimeout: ReturnType<typeof setTimeout> | null = null;

let activeRequests = 0;

const start = () => {
  activeRequests++;

  if (activeRequests > 1) return;

  if (timer) clearInterval(timer);
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  progress.value = 0;
  visible.value = true;

  timer = setInterval(() => {
    if (progress.value < 90) {
      progress.value += Math.random() * 2 + 0.5;
      if (progress.value > 90) progress.value = 90;
    } else {
      if (timer) clearInterval(timer);
      timer = null;
    }
  }, 100);
};

const finish = () => {
  if (activeRequests > 0) activeRequests--;

  if (activeRequests > 0) return;

  if (timer) {
    clearInterval(timer);
    timer = null;
  }

  if (hideTimeout) {
    clearTimeout(hideTimeout);
  }

  progress.value = 100;

  hideTimeout = setTimeout(() => {
    visible.value = false;
    progress.value = 0;
    hideTimeout = null;
  }, 300);
};

export const useProgressBar = () => {
  return {
    progress,
    visible,
    start,
    finish,
  };
};
